import EmailSenderSettings from "./EmailSenderSettings";

export default EmailSenderSettings;
